import { get, post } from './axios'
import config from './config'
const common = {
  // 格式化时间
  formatTime(date, num) {
    if (date) {
      if (typeof (date) === 'number' || typeof (date) === 'object' || typeof (date) === 'string') {
        date = new Date(date)
      }
      const year = date.getFullYear()
      const month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      const hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      const minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      const second = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      switch (num) {
        case 1:
          return [year, month, day].join('-')
        case 2:
          return [year, month, day].join('/')
        case 3:
          return [year, month, day].join('-') + '' + [hour, minute, second].join(':')
        case 4:
          return [year, month, day].join('.')
        default:
          return [year, month, day].join('-')
      }
    } else {
      return ''
    }
  },
  getQueryString(name, path) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    var r = path.split('?')[1].match(reg)
    if (r != null) return unescape(r[2]); return null
  },
  getUnionId(code, state) {
    const url = '/wechat/open/userInfo?code=' + code + '&state=' + state + '&platform=I'
    return new Promise(function(resolve, reject) {
      get(url).then(res => {
        if (res.code == 0) {
          resolve(res.data.unionId)
        } else {
          reject(res.code)
        }
      })
    })
  },
  // 获取字典数据接口
  getDictionaryItems(code) {
    const url = '/base/dictionaryItem/getDictionaryItemsByCode/' + code
    return new Promise(function(resolve, reject) {
      get(url).then(res => {
        if (res.code == 0) {
          resolve(res.data)
        } else {
          reject(res)
        }
      })
    })
  },
  // 获取字典数据接口
  refreshToken() {
    const refreshToken = window.localStorage.getItem('refreshToken')
    const url = '/authentication/auth/refreshToken'
    const ajaxData = {
      refreshToken: refreshToken,
      client: 'Basic c2VydmljZV9pbnZlc3RpZ2F0b3I6MTIzNDU2'
    }
    return new Promise(function(resolve, reject) {
      post(url, ajaxData).then(res => {
        if (res) {
          window.localStorage.setItem('token', res.data.accessToken)
          window.localStorage.setItem('account', JSON.stringify(res.data.account))
          resolve(1)
        } else {
          reject(-1)
        }
      })
    })
  },
  // 获取角色
  getRoles() {
    const url = '/base/permissions/investigator/menu'
    return new Promise(function(resolve, reject) {
      get(url).then(res => {
        // console.log(res);
        if (res.code == 0) {
          const json = {}
          res.data.options = res.data.operations && res.data.operations.map((item) => {
            return item.code
          })
          const roles = res.data.menus || []
          for (let i = 0; i < roles.length; i++) {
            if (!json[roles[i].code]) {
              json[roles[i].code] = roles[i].childList
            }
          }
          // json['settlement:-'].push({
          //   name: '报酬结算管理',
          //   href: '',
          //   // menuLogo: 'icon-market-01',
          //   hasChildList: true,
          //   childList: [
          //     {
          //       href: '/settlement/reward/unsettledCase',
          //       name: '待结算案件',
          //       hasChildList: false
          //     },
          //     {
          //       href: '/settlement/reward/statementManagement',
          //       name: '结算单管理',
          //       hasChildList: false
          //     },
          //     {
          //       href: '/settlement/reward/collectionRecord',
          //       name: '收款记录',
          //       hasChildList: false
          //     }
          //   ]
          // })
          // console.log(json['settlement:-'])

          // json['settlement:-'].push(
          //   {
          //     name: '区域等级配置',
          //     href: '/clue/regionConfig',
          //     menuLogo: 'icon-market-01',
          //     hasChildList: false
          //   })

          /* json['system:-'] && json['system:-'].push({
            name: '公告栏',
            href: '/settings/noticeBank',
            menuLogo: 'icon-home-09',
            hasChildList: false
          }) */

          res.data.roles = json
          resolve(res.data)
        } else {
          reject(res)
        }
      }, err => {
        reject(err)
      })
    })
  },
  tm_status_class(status) {
    if (status.indexOf('无效') !== -1) {
      return 'tmstatus-invalid'
    }
    if (status.indexOf('等待') !== -1) {
      return 'tmstatus-wait'
    }
    if (status.indexOf('异议') !== -1) {
      return 'tmstatus-objection'
    }
    if (status.indexOf('公告') !== -1) {
      return 'tmstatus-review'
    }
    return 'tmstatus-success'
  },
  // 根据对象的某个key排序
  sort_object(property) {
    return function(obj1, obj2) {
      var value1 = obj1[property]
      var value2 = obj2[property]
      return value1 - value2
    }
  },
  // 转换千分数
  formateNumber(data, unit, precision) {
    const prec = precision || 2
    const unitStr = unit === '' ? unit : '￥'
    if (data === 0) { return unitStr + '0' }
    if (data === '' || !data) { return '' }
    const str = (typeof data === 'number' && !isNaN(data)) ? (data.toFixed(prec) + '') : data
    const arr = str.split('.')
    let formateStr = Number(arr[0]).toLocaleString()
    if (arr[1]) {
      formateStr += `.${arr[1]}`
    } else {
      formateStr += '.00'
    }
    return unitStr + formateStr
  },
  // 数字转千分位
  format_with_regex(val) {
    if (!val) return 0
    const reg = /\d{1,3}(?=(\d{3})+$)/g
    return (val + '').replace(reg, '$&,')
  },
  debounce(fn, delay) {
    // 记录上一次的延时器
    var timer = null
    var delay = delay || 200
    return function() {
      var args = arguments
      var that = this
      // 清除上一次延时器
      clearTimeout(timer)
      timer = setTimeout(function() {
        fn.apply(that, args)
      }, delay)
    }
  },
  throttle(fn, delay) {
    var lastTime
    var timer
    var delay = delay || 200
    return function() {
      var args = arguments
      // 记录当前函数触发的时间
      var nowTime = Date.now()
      if (lastTime && nowTime - lastTime < delay) {
        clearTimeout(timer)
        timer = setTimeout(function () {
          // 记录上一次函数触发的时间
          lastTime = nowTime
          // 修正this指向问题
          fn.apply(this, args)
        }, delay)
      } else {
        lastTime = nowTime
        fn.apply(this, args)
      }
    }
  },
  // 根据传入的key和string 返回对应的数组对象
  strMapArr(obj) {
    const arrKey = []; const arr = []
    for (const key in obj) {
      arrKey.push(key)
    }
    if (!obj[arrKey[0]]) {
      return []
    }
    let json = {}
    const len = obj[arrKey[0]].split(',').length
    for (let i = 0; i < len; i++) {
      json = {}
      arrKey.forEach(item => {
        json[item] = obj[item].split(',')[i]
        if (typeof Number(json[item]) === 'number' && !isNaN(Number(json[item]))) {
          json[item] = Number(json[item])
        }
      })
      arr.push(json)
    }
    return arr
  },
  // 判断文件类型
  /** **
    * 返回值说明：
    * image是图片类型（可以使用viewer预览）
    * wps是文件类型（可以是用wps打开）
    * other是其他类型（直接使用a标签打开）
    ****/
  getFileType(mediaType) {
    if (mediaType.indexOf('image') != -1) {
      return 'image'
    } else if (mediaType.indexOf('.document') != -1 ||
                mediaType.indexOf('msword') != -1 ||
                mediaType.indexOf('.sheet') != -1 ||
                mediaType.indexOf('.ms-excel') != -1 ||
                mediaType.indexOf('pdf') != -1 ||
                mediaType.indexOf('text/plain') != -1 ||
                mediaType.indexOf('powerpoint') != -1 ||
                mediaType.indexOf('presentation') != -1) {
      return 'wps'
    } else {
      return 'other'
    }
  },
  /**
     *
     * @param {*} key 获取cookie中的内容
     * @returns
     */
  getCookie(key) {
    const arr = document.cookie.replace(/\s/g, '').split(';')
    for (var i = 0; i < arr.length; i++) {
      var tempArr = arr[i].split('=')
      if (tempArr[0] == key) {
        return decodeURIComponent(tempArr[1])
      }
    }
    return ''
  },
  getPublicUrl(key) {
    const url = '/base/cos/presigned-url/ap-guangzhou/' + config.uploadPrivateUrl + '?keys=' + key
    return new Promise(function(resolve, reject) {
      get(url).then(res => {
        if (res.code == 0) {
          const pubUrl = res.data[0]
          resolve(pubUrl)
        }
      })
    })
  }
}
export default common



// WEBPACK FOOTER //
// ./src/libs/util.js